var _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKmf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "160px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "10 40                    20 40                    50 75                    50 40                    60 40                    85 100                    110 40                    155 40                     155 50                     120 50                     120 75                     145 75                     145 85                     120 85                     120 120                     110 120                     110 65                     85 120                     60 65                     60 120                     50 120                     50 80                     20 120                     10 120                     40 77.5                     10 40",
    stroke: "white",
    strokeWidth: 2,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmf);
export default __webpack_public_path__ + "static/media/kmf.25c79141071671a8be93deb5b94330e1.svg";
export { ForwardRef as ReactComponent };